import { Theme } from '@material-ui/core';

const styles = (theme: Theme) =>
  ({
    title: {
      '& h2': {
        paddingTop: 16,
        paddingBottom: 16,
      },
    },
    containerAll: {
      gap: '32px',
      flexWrap: 'nowrap',
    },
    containerContact: {
      width: '35%',
    },
    contentContact: {
      // maxWidth: 500,
      margin: 'auto',
      marginBottom: 24,
      textAlign: 'center',
      lineHeight: '18px',
      '& > span': {
        color: theme.palette.secondary.main,
      },
      '& > h4': {
        fontSize: 17,
      },
      '& > h5': {
        marginTop: 16,
        paddingBottom: 0,
        fontSize: 22,
        fontFamily: 'Mulish',
      },
      '& a': {
        textDecoration: 'none',
        color: theme.palette.secondary.main,
      },
      '& > h6': {
        fontSize: 16,
        lineHeight: '20px',
        color: theme.palette.secondary.main,
      },
    },
    errorContainer: { marginTop: '12px' },
    btnActions: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: 16,
    },
    contentForm: {
      width: '58%',
      // marginRight: '32px',
      '& .MuiFormControl-marginNormal': {
        width: '100%',
      },
    },

    '@media all and (max-width: 1377px)': {
      containerAll: {
        flexDirection: 'column',
      },
      contentForm: { width: 'calc(100% - 48px)' },
      containerContact: { width: '100%' },
    },
  } as any);

export default styles;
